import { event } from "jquery";

export const jelentes = {

    init: function () {
        document.querySelector('#jelentesSelectAll').addEventListener("click", this.selectAllJelentesDolgozok.bind(this));
        document.querySelector('#jelentesReverseAll').addEventListener("click", this.reverseJelentesDolgozok.bind(this));
        document.querySelector('#jelentesDeselectAll').addEventListener("click", this.deselectAllJelentesDolgozok.bind(this));
    },

    selectAllJelentesDolgozok: function() {
        Array.from(document.querySelectorAll('input[type="checkbox"][id^="dolgozo"]')).forEach(el => el.checked = true);
    },

    reverseJelentesDolgozok: function() {
        Array.from(document.querySelectorAll('input[type="checkbox"][id^="dolgozo"]')).forEach(el => el.checked = !el.checked);
    },

    deselectAllJelentesDolgozok: function() {
        Array.from(document.querySelectorAll('input[type="checkbox"][id^="dolgozo"]')).forEach(el => el.checked = false);
    }

};
